<!-- 投票规则说明 -->
<template>
  <div class="component-header">
    <!-- Banner 开始 -->
    <div class="banner"></div>
    <!-- Banner 结束 -->
    <!-- 导航 开始 -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ComponentHeader",
  data() {
    return {
      // 导航菜单列表
      // name: 菜单名称
      // to  : 点击菜单后要跳转的路由路径
      navList: [
        { name: "首页", to: "/" },
        { name: "信息资讯", to: "/news/information-dynamics" },
        { name: "褒扬纪念政策", to: "/praise-the-commemoration-policy" },
        { name: "烈士英名录", to: "/martyr/list-of-martyrs" },
        { name: "烈士纪念设施", to: "/cemetery-directories" },
        { name: "VR数字展馆", to: "/vr" },
        { name: "网上祭扫", to: "/sacrifice" },
        { name: "远程代祭", to: "/replace" }
      ],
      isphone: false
    };
  },
  computed: {
    ...mapState([
      "userinfo", // 用户信息
      "headerNavIndex" // 当前激活的导航菜单的下标
    ])
  },
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    /**
     * ##########################################################################################
     * @description 头像下拉菜单点击事件
     * @param {String} command : dropdown-item 的指令
     * ##########################################################################################
     */

    handleCommand(command) {
      console.log("点击了菜单:", command);
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
.component-header {
  position: relative;
  /* min-width: 1200px; */
  max-width: 980px;
  margin: 0 auto;
}

.banner {
  padding-top: 58px;
  /* margin-top: 58px; */
  display: block;
  width: 100%;
  height: auto;
}

.content {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  padding-bottom: 58px;
}

.top {
  flex-shrink: 0;
  height: 80px;
  border-bottom: 1px solid rgba(255, 238, 205, 0.2);
}

.top .main-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top .logo {
  height: 52px;
}

.top .links {
  display: flex;
  align-items: center;
}

.top .link {
  font-size: 16px;
  color: #ffffff;
  width: 75px;
  height: 38px;
  line-height: 38px;
  text-align: center;
}

.top .link-register {
  background: linear-gradient(0deg, #f7ba5e 0%, #ffeeb4 100%);
  border-radius: 10px;
  color: var(--main-color);
  font-weight: bold;
}

.mid {
  flex: 1;
}

.mid .main-content {
  height: 100%;
  display: flex;
  align-items: center;
}

.mid .web-title {
  height: 73px;
}
.navspc {
  top: 90px;
}
.navsmobile {
  top: 70px;
}
.navs {
  padding: 0 60px;
  font-weight: bold;
  box-sizing: border-box;
  line-height: 2em;
  height: 58px;
  position: absolute;
  left: 0;
  z-index: 20;
  font-size: 20px;
}
.navs .guizetitle {
  font-size: 30px;
  font-weight: normal;
  color: var(--main-color);
  text-align: center;
  padding: 30px 0;
}
.navs .main-content {
  height: 100%;
  display: flex;
}
.navs .guizecontent {
  margin-bottom: 20px;
  line-height: 2em;
}
.navs .guizecontent .jt {
  width: 20px;
  height: 20px;
  position: relative;
  top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/votingrules.vue